export default __webpack_public_path__ + "static/cursor_click_01-d6ae52fddb2f8d1c53c45682474d00d2.wav";